import React from 'react';
import { nftMarketplaceUrl } from 'utils/socials';
import { BREAKER_CONTRACT_ADDRESS } from 'utils/contract';
import { GenericSharing } from './Generic';
import { ShareDropdownButton } from '../ShareDropdownButton';

export function BreakerSharing({ breaker }: BreakerShareDropdownProps) {
  const openSeaLink = nftMarketplaceUrl.openSea({
    contract: BREAKER_CONTRACT_ADDRESS,
    nftId: breaker.id,
  });

  const fallback = {
    text: `Check out my #DuskBreaker on OpenSea: ${openSeaLink.toString()}`,
    link: openSeaLink,
  };

  return (
    <ShareDropdownButton data={fallback}>
      <GenericSharing
        openSeaLink={openSeaLink}
        data={{
          twitter: {
            text: `Check out my #DuskBreaker on OpenSea by @duskbreakers: ${openSeaLink.toString()}`,
            link: openSeaLink,
          },
          telegram: {
            text: `Check out my #DuskBreaker on OpenSea`,
            link: openSeaLink,
          },
          fallback,
        }}
      />
    </ShareDropdownButton>
  );
}

export function GalleryBreakerShareDropdown({
  breaker,
  text,
  align = 'right',
}: BreakerShareDropdownProps) {
  const openSeaLink = nftMarketplaceUrl.openSea({
    contract: BREAKER_CONTRACT_ADDRESS,
    nftId: breaker.id,
  });

  const fallback = {
    text: `Check out this character from the #DuskBreakers Gallery: ${openSeaLink.toString()}`,
    link: openSeaLink,
  };

  return (
    <ShareDropdownButton data={fallback} text={text}>
      <GenericSharing
        openSeaLink={openSeaLink}
        data={{
          twitter: {
            text: `Check out this character from the @DuskBreakers Gallery: ${openSeaLink.toString()}`,
            link: openSeaLink,
          },
          telegram: {
            text: `Check out this character from the #DuskBreakers Gallery`,
            link: openSeaLink,
          },
          fallback,
        }}
        align={align}
      />
    </ShareDropdownButton>
  );
}

export type BreakerShareDropdownProps = {
  breaker: { id: number };
  text?: string;
  align?: 'left' | 'right';
};
